(function () {
  if (customElements.get('bonfi-quiz')) return;
  customElements.define('bonfi-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.answers = {};
      this.labels = {};
      this.steps = Array.from(this.querySelectorAll('.bonfi-quiz__step'));
      this.questionCount = this.steps.length - 1;
      this.bar = this.querySelector('.bonfi-quiz__progress-bar');
      this.counter = this.querySelector('[data-counter]');
      this.strings = JSON.parse(this.querySelector('[data-quiz-strings]').textContent);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.products = Array.from(this.querySelectorAll('.bonfi-quiz__result')).map(el => ({
        el: el, tags: this.parseTags(el.dataset.tags), family: el.dataset.family,
        cards: Array.from(el.querySelectorAll('.bonfi-quiz__card'))
      }));
      this.currency = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.clickHandler = this.onClick.bind(this);
      this.changeHandler = event => { if (event.target.matches('[data-include]')) this.updateSelection(); };
      this.addEventListener('click', this.clickHandler);
      this.addEventListener('change', this.changeHandler);
      this.setProgress(0);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
      this.removeEventListener('change', this.changeHandler);
      window.clearTimeout(this.transitionTimer);
      this.transitioning = false;
      this.initialized = false;
    }

    text(key, values) {
      let text = this.strings[key] || '';
      Object.keys(values || {}).forEach(key => { text = text.replaceAll('{' + key + '}', values[key]); });
      return text;
    }

    onClick(event) {
      if (this.transitioning || this.adding) return;
      const option = event.target.closest('.bonfi-quiz__option');
      if (option) {
        const step = option.closest('.bonfi-quiz__step');
        if (step.hidden) return;
        step.querySelectorAll('.bonfi-quiz__option').forEach(el => {
          el.classList.toggle('is-selected', el === option);
          el.setAttribute('aria-pressed', String(el === option));
        });
        this.answers[step.dataset.dim] = option.dataset.value;
        this.labels[step.dataset.dim] = option.dataset.label;
        const index = this.steps.indexOf(step);
        if (index === this.questionCount - 1) this.showResult();
        else this.goTo(index, index + 1);
        return;
      }
      if (event.target.closest('[data-back]')) {
        const current = this.steps.indexOf(event.target.closest('.bonfi-quiz__step'));
        this.goTo(current, current - 1);
      } else if (event.target.closest('[data-add-all]')) {
        this.addAll();
      } else if (event.target.closest('[data-edit-answers]')) {
        this.goTo(this.questionCount, 0);
      } else if (event.target.closest('[data-restart]')) {
        this.answers = {};
        this.labels = {};
        this.querySelectorAll('.bonfi-quiz__option').forEach(el => {
          el.classList.remove('is-selected');
          el.setAttribute('aria-pressed', 'false');
        });
        this.goTo(this.questionCount, 0);
      }
    }

    goTo(fromIndex, toIndex) {
      const from = this.steps[fromIndex], to = this.steps[toIndex];
      if (!from || !to || this.transitioning) return;
      this.transitioning = true;
      this.setProgress(toIndex);
      const swap = () => {
        from.hidden = true;
        from.classList.remove('is-active', 'is-leaving');
        to.hidden = false;
        to.classList.add('is-active');
        this.transitioning = false;
        const heading = to.querySelector('legend, [data-result-heading]');
        if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
        const rect = this.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight / 2) this.scrollIntoView({ behavior: this.reduced ? 'auto' : 'smooth', block: 'start' });
        this.dispatchEvent(new CustomEvent('bonfi-quiz:step', { bubbles: true, detail: { step: toIndex, version: this.dataset.quizVersion } }));
      };
      if (this.reduced) swap();
      else { from.classList.add('is-leaving'); this.transitionTimer = window.setTimeout(swap, 180); }
    }

    setProgress(index) {
      this.bar.style.width = Math.min(index, this.questionCount) / this.questionCount * 100 + '%';
      this.counter.textContent = index >= this.questionCount ? this.text('routine') : this.text('question', { step: index + 1, count: this.questionCount });
    }

    parseTags(str) {
      const map = {};
      (str || '').toLowerCase().split(',').forEach(pair => {
        const parts = pair.trim().split(':');
        if (parts.length !== 2) return;
        if (!map[parts[0]]) map[parts[0]] = {};
        map[parts[0]][parts[1]] = true;
      });
      return map;
    }

    pickCard(product) {
      const size = this.answers.size === 'travel' ? 'travel' : 'full';
      return product.cards.find(card => card.dataset.available === 'true' && card.dataset.card === size);
    }

    rankProducts() {
      const a = this.answers;
      return this.products.filter(p => {
        const t = p.tags;
        if (!t.hair || !t.hair[a.hair]) return false;
        if (!this.pickCard(p)) return false;
        const isWash = !!(t.cat && t.cat.wash);
        const isBundle = !!(t.cat && t.cat.bundle);
        if (isBundle && (a.size !== 'bundle' || a.time !== 'routine')) return false;
        if (a.time === 'quick' && !(t.time && t.time.quick)) return false;
        if (a.time !== 'washday' && isWash) return false;
        return !!(t.goal && t.goal[a.goal]) || (a.time === 'washday' && isWash);
      }).map(p => {
        const t = p.tags;
        let score = (t.goal && t.goal[a.goal] ? 20 : 0) + (t.time && t.time[a.time] ? 4 : 0);
        score += Number(p.el.dataset.boost || 0);
        if (t.feel && t.feel[a.feel]) score += 3;
        if (a.texture !== 'any' && t.texture && t.texture[a.texture]) score += 6;
        if (a.time === 'washday' && p.family === 'shampoo') score += 90;
        else if (a.time === 'washday' && p.family === 'conditioner') score += 85;
        if (a.goal === 'dry' && t.cat && t.cat.treat) score += 10;
        if (a.goal === 'tangles' && t.cat && t.cat.treat) score += 10;
        if ((a.goal === 'definition' || a.goal === 'hold') && t.cat && t.cat.style) score += 10;
        return { product: p, score: score };
      }).sort((a, b) => b.score - a.score || a.product.family.localeCompare(b.product.family));
    }

    chooseProducts() {
      const ranked = this.rankProducts();
      if (this.answers.size === 'bundle') {
        const bundle = ranked.find(item => item.product.tags.cat && item.product.tags.cat.bundle);
        if (bundle) return [bundle.product];
      }
      const chosen = [], families = new Set(), variants = new Set(), categories = {};
      const max = this.answers.time === 'quick' ? 1 : 3;
      ranked.forEach(item => {
        const p = item.product;
        const category = p.family === 'shampoo' ? 'cleanse' : p.family === 'conditioner' ? 'condition' : Object.keys(p.tags.cat || {})[0] || 'other';
        const card = this.pickCard(p);
        if (chosen.length >= max || families.has(p.family) || variants.has(card.dataset.variantId) || category === 'bundle') return;
        const cap = category === 'wash' ? 2 : 1;
        if ((categories[category] || 0) >= cap) return;
        families.add(p.family); variants.add(card.dataset.variantId);
        categories[category] = (categories[category] || 0) + 1;
        chosen.push(p);
      });
      return chosen;
    }

    showResult() {
      const chosen = this.chooseProducts();
      this.products.forEach(p => { p.el.hidden = true; p.el.classList.remove('is-hero'); });
      chosen.forEach((p, i) => {
        const card = this.pickCard(p);
        p.el.hidden = false;
        p.el.classList.toggle('is-hero', i === 0);
        p.el.querySelector('[data-rank]').textContent = this.text(i === 0 ? 'hero' : 'extra');
        p.cards.forEach(c => { c.hidden = c !== card; });
        card.querySelector('[data-include]').checked = true;
        card.querySelector('[data-match-reason]').textContent = this.text(p.tags.goal && p.tags.goal[this.answers.goal] ? 'match' : 'wash', { goal: this.labels.goal });
        this.querySelector('[data-results]').appendChild(p.el);
      });
      this.querySelector('[data-result-summary]').textContent = this.text('summary', { hair: this.labels.hair, goal: this.labels.goal });
      this.querySelector('[data-quiz-empty]').hidden = chosen.length > 0;
      const context = this.querySelector('[data-quiz-context]');
      context.hidden = !(chosen.length && this.answers.size === 'bundle' && !(chosen[0].tags.cat && chosen[0].tags.cat.bundle));
      context.textContent = context.hidden ? '' : this.text('bundle_fallback');
      const note = this.querySelector('[data-add-all-note]'); note.hidden = true; note.textContent = '';
      this.querySelector('[data-add-all]').hidden = chosen.length === 0;
      this.querySelector('[data-selection-help]').hidden = chosen.length === 0;
      this.querySelector('[data-quiz-total]').hidden = chosen.length === 0;
      this.updateSelection();
      this.goTo(this.questionCount - 1, this.questionCount);
      this.dispatchEvent(new CustomEvent('bonfi-quiz:result', { bubbles: true, detail: { answers: Object.assign({}, this.answers), families: chosen.map(p => p.family), version: this.dataset.quizVersion } }));
    }

    selectedCards() {
      return Array.from(this.querySelectorAll('.bonfi-quiz__result:not([hidden]) .bonfi-quiz__card:not([hidden])')).filter(card => card.dataset.available === 'true' && card.querySelector('[data-include]').checked);
    }

    updateSelection() {
      const cards = this.selectedCards();
      const cents = cards.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
      this.querySelector('[data-quiz-total]').textContent = this.text('total', { price: this.currency.format(cents / 100), count: cards.length });
      const button = this.querySelector('[data-add-all]');
      if (!this.addLabel) this.addLabel = button.querySelector('[data-add-all-label]').textContent;
      button.disabled = this.adding || !cards.length;
      button.querySelector('[data-add-all-label]').textContent = this.adding ? this.text('adding') : cards.length ? this.addLabel : this.text('select');
    }

    async addAll() {
      const cards = this.selectedCards();
      if (!cards.length || this.adding) return;
      const items = cards.map(card => ({ id: Number(card.dataset.variantId), quantity: 1 }));
      this.adding = true;
      this.updateSelection();
      this.setAttribute('aria-busy', 'true');
      const note = this.querySelector('[data-add-all-note]'); note.hidden = true;
      try {
        const res = await fetch(this.dataset.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!res.ok) throw new Error('cart');
        window.location.href = this.dataset.cartUrl;
      } catch (error) {
        this.adding = false;
        this.removeAttribute('aria-busy');
        this.updateSelection();
        note.hidden = false;
        note.textContent = this.text('error');
      }
    }
  });
})();
